import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Box, Hide, getPaletteColor } from 'pcln-design-system'

import { AttributesFilters } from './AttributesFilters'
import { TimeFilters } from './TimeFilters'
import { StopsFilters } from './StopsFilters'
import { AirlinesFilters } from './AirlinesFilters'
import { AirportsFilters } from './AirportsFilters'
import { SortOptions } from './SortOptions'
import { EmployeeDiscount } from './EmployeeDiscount'
import { useSelector } from 'react-redux'
import { markInteractionEnd, markInteractionStart } from '@pcln/measure'
import { useDebouncedListingsFilterCall } from '@mfs/client/listings-client/components/Filters/useDebouncedListingsFilterCall/useDebouncedListingsFilterCall'
import pclnExpt from '@pcln/experimentation'
import { useIsMobile } from '../../helpers/useIsMobile'

const AIR_LISTINGS_CHANGE_FILTER_ORDER = 'AIR_LISTINGS_CHANGE_FILTER_ORDER'

const FilterWrapper = styled(Box)`
  color: ${getPaletteColor('text.base')};
`

function Filters() {
  const { debouncedListingsFilterCall } = useDebouncedListingsFilterCall()
  const currentMobileFilter = useSelector((state) => state.uiToggles?.currentMobileFilter) ?? ''
  const hasUSDestinationsOnly = useSelector((state) => state.pclnBootstrapData?.hasUSDestinationsOnly)
  const isReshopExperience = useSelector((state) => state.pclnBootstrapData?.isReshopExperience)
  const listingsHasErrored = useSelector((state) => state.listingsHasErrored)
  const numOfSlices = useSelector((state) => state.pclnBootstrapData?.searchRequest?.slices?.length)
  const pclnBootstrapData = useSelector((state) => state.pclnBootstrapData) ?? {}
  const tripType = useSelector((state) => state.listingsMetaData?.tripType) ?? ''
  const isMobile = useIsMobile()

  useEffect(() => {
    if (!isMobile && !listingsHasErrored) {
      pclnExpt.fireImpression(AIR_LISTINGS_CHANGE_FILTER_ORDER)
    }
  }, [isMobile, listingsHasErrored])

  const isChangeFilterOrderVariant = pclnExpt.isVariant(AIR_LISTINGS_CHANGE_FILTER_ORDER)

  const fireListingsFilterCall = (sortOptions) => {
    markInteractionStart('FLIGHTS_DESKTOP_FILTERS_CLICK')
    // this check is to avoid listings call on mobile before hitting apply
    if (!currentMobileFilter) {
      debouncedListingsFilterCall(pclnBootstrapData, 'filter', sortOptions)
    }
    markInteractionEnd('FLIGHTS_DESKTOP_FILTERS_CLICK')
  }

  if (listingsHasErrored) return null

  const attributeFilters = (
    <Hide xs sm md>
      <AttributesFilters
        changeHandler={fireListingsFilterCall}
        tripType={tripType}
        expandedMargin={isChangeFilterOrderVariant}
      />
    </Hide>
  )

  const airportsFilters = <AirportsFilters changeHandler={fireListingsFilterCall} />

  return (
    <FilterWrapper>
      {pclnBootstrapData?.enableEmployeeDeals && <EmployeeDiscount />}
      <SortOptions changeHandler={fireListingsFilterCall} numOfSlices={numOfSlices} />

      {!isChangeFilterOrderVariant && attributeFilters}

      <StopsFilters changeHandler={fireListingsFilterCall} hasUSDestinationsOnly={!!hasUSDestinationsOnly} />
      {!isReshopExperience ? <AirlinesFilters changeHandler={fireListingsFilterCall} /> : null}

      {isChangeFilterOrderVariant && airportsFilters}
      {isChangeFilterOrderVariant && attributeFilters}

      <TimeFilters changeHandler={fireListingsFilterCall} />

      {!isChangeFilterOrderVariant && airportsFilters}
    </FilterWrapper>
  )
}

export { Filters as default } // still being lazy loaded in the V1 path
